/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Witty_Careful_Elk_AdoreInputs */

const fr_witty_careful_elk_adore = /** @type {(inputs: Witty_Careful_Elk_AdoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cours du jour`)
};

/**

* @param {Witty_Careful_Elk_AdoreInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const witty_careful_elk_adore = /** @type {((inputs?: Witty_Careful_Elk_AdoreInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Witty_Careful_Elk_AdoreInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_witty_careful_elk_adore(inputs)
});